export const MOBILE_WIDTH = 640

export function isMobileSize(): boolean {
  return typeof window !== 'undefined' && window.innerWidth <= MOBILE_WIDTH
}

export function isDesktopSize(): boolean {
  return !isMobileSize()
}
